export default "/_next/static/media/AboutDigikalaVideo.30cf695062d2ea591f7429872b623204.mp4";